export enum Language {
  En = 'en',
  Ro = 'ro',
}
